import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './DemoBanner.css';

// Shown at the top of every page for demo accounts (users.is_demo), whose data all comes from
// the perturbed demo_data dataset (see api/app.py _DEMO_DATASET_OVERRIDES). Deliberately not
// inside <Navigation>, which is hidden when printing — printed demo reports keep the notice.
// Also asks /api/config (server session), since a login cached before the demo flag existed
// has no `demo` field on currentUser.
function DemoBanner() {
  const { currentUser } = useAuth();
  const [serverDemo, setServerDemo] = useState(false);

  useEffect(() => {
    if (!currentUser) return;
    let cancelled = false;
    fetch('/api/config')
      .then(res => res.json())
      .then(data => { if (!cancelled) setServerDemo(!!data.demo); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [currentUser]);

  if (!currentUser?.demo && !serverDemo) return null;
  return (
    <div className="demo-banner" role="note">
      This is mock data and not real trackman data.
    </div>
  );
}

export default DemoBanner;
